module.exports = __webpack_public_path__ + "img/icon_dia.cecef3fc.svg";